import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}



export default function MultiSelectPlaceholder({ options, selectedValues, handleTypeChange,setErrorField,errorfield ,SelectedTypes}) {
  const theme = useTheme();
  const handleChange = (event) => {
    const { value } = event.target;
    handleTypeChange(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <div>
      <FormControl sx={{ m: 0.5, width: 200, mt: 1 }}   error={errorfield}  > 
        <div>
        <div>
    <Select
      multiple
      displayEmpty
      value={SelectedTypes}
      onChange={handleChange}
      input={<OutlinedInput sx={{ padding: "4px", height: 30 }} />} 
      renderValue={(selected) => (selected.length === 0 ? <em>Select Type</em> : selected.join(", "))}
      MenuProps={MenuProps}
      inputProps={{ "aria-label": "Without label" }}
      sx={{ 
        fontSize: "14px", 
        height: 32, 
        width: "150px", // ✅ Fixed width
        minWidth: "150px", 
        maxWidth: "150px", 
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }} 
    >
      <MenuItem disabled value="">
        <em>Type</em>
      </MenuItem>
      {options.map((name) => (
        <MenuItem key={name} value={name} style={getStyles(name, selectedValues, theme)}>
          {name}
        </MenuItem>
      ))}
    </Select>
</div>

        </div>
        {errorfield && <FormHelperText>At least one option must be selected</FormHelperText>} 
      </FormControl>
    </div>
  );
}

